import { createElement } from '../../adapters/dom';

export function createExpiredTemplate(): HTMLDivElement {
  const wrapper = createElement('div', {
    className: 'cpw-screen cpw-screen-expired'
  }) as HTMLDivElement;

  const title = createElement('h3', {
    className: 'cpw-title',
    textContent: 'Время оплаты истекло'
  });

  const description = createElement('p', {
    className: 'cpw-text',
    textContent: 'Создайте новый платёж или выберите другой способ оплаты.'
  });

  wrapper.append(title, description);

  return wrapper;
}